/**
 * On start, params are stored from GET parameters.
 * Application is also stored for display and verification information.
 */
import Action from 'lib/interfaces/Action';

export enum CreatePersonaActionType {
  SetStatus = 'create-persona/SET_STATUS',
}

export enum CreatePersonaStatus {
  CtaNotShown = 'cta-not-shown',
  CtaShown = 'cta-shown',
  CtaDismissed = 'cta-dismissed',
  PersonaCreated = 'persona-created',
}

interface SetStatusPayload {
  status: CreatePersonaStatus;
}

export function setCreatePersonaStatus(
  status: CreatePersonaStatus,
): Action<CreatePersonaActionType.SetStatus, SetStatusPayload> {
  return {
    type: CreatePersonaActionType.SetStatus,
    payload: {
      status,
    },
  };
}

export type CreatePersonaActions = Action<CreatePersonaActionType.SetStatus, SetStatusPayload>;
